import PropTypes from "prop-types"
import React from "react"
import clsx from "classnames"
import { LockOpenIcon, LockClosedIcon } from "@heroicons/react/20/solid"

const ToggleLockButton = ({ children, className = "", locked, onClick }) => {
  const LockIcon = locked ? (
    <LockOpenIcon className="size-3" aria-hidden data-testid="lock-open-icon" />
  ) : (
    <LockClosedIcon className="size-3" aria-hidden data-testid="lock-closed-icon" />
  )

  return (
    <button
      type="button"
      className={clsx("inline-flex items-center gap-x-1.5 text-sm font-semibold", className)}
      onClick={onClick}
    >
      {children}
      {LockIcon}
    </button>
  )
}

ToggleLockButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  locked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default ToggleLockButton
